export const printAuthErrorMessage = (errMsg: unknown): string => {
  const origMessage = `${errMsg}`.trim();
  const dot = origMessage.length > 0 && origMessage[origMessage.length - 1] !== '.' ? '.' : '';
  return `${origMessage}${dot} Contact your administrator or support@growegy.com.`;
};
